// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf } from "@altostra/type-validations";

export const isEngagementApiSuppressionListsResult = objectOf({
  results: arrayOf(objectOf({})),
});
